import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tgrtWrap: {
    '& > div': {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  bold: {
    fontWeight: 'bold',
  },
  trgt: {
    color: theme.palette.table.cell.purple,
  },
  orderAmt: {
    color: theme.palette.primary.contrastText,
  },
}));

// VariousCell 컴포넌트는 ShoppingCell로 점차적으로 대체시킬 예정입니다.
const VariousCell = (props) => {
  const classes = useStyles();
  const { type, bold = false, item1, item2, item3 } = props;
  return (
    (type === 'TRGT' || type === 'ECPM') && (
      <div className={clsx(bold && classes.bold)}>
        <div>
          {item1}
          {typeof item2 !== 'undefined' && type === 'TRGT' ? (
            <span className={classes.trgt}>({item2})</span>
          ) : (
            <>
              <br />({item2})
            </>
          )}
        </div>
        {typeof item3 !== 'undefined' && (
          <p className={classes.orderAmt}>{item3}</p>
        )}
      </div>
    )
  );
};

export default VariousCell;
